import { render, staticRenderFns } from "./CsTabItem.vue?vue&type=template&id=712edc50&"
import script from "./CsTabItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsTabItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports